import { Button, Col, Divider, Form, Input, Row, Space, Switch, Typography } from "antd";
import ActionFormItems from "../../../components/FormItems/ActionFormItems";
import TriggerFormItems from "../../../components/FormItems/TriggerFormItems";
import {
  BulbOutlined,
  CalendarOutlined,
  CloseOutlined,
  CloudUploadOutlined, MessageOutlined, SaveOutlined, SearchOutlined, ShopOutlined, UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import React from "react";

const cards = [
  {
    key: "WEBHOOK",
    title: "Webhook",
    description: "Realize uma requisição http customizada.",
    icon: <CloudUploadOutlined style={{ marginRight: 8 }} />
  },
  {
    key: "KNOWLEDGE",
    title: "Conhecimento",
    description: "Consulta informações específicas do conhecimento do assistente.",
    icon: <SearchOutlined style={{ marginRight: 8 }} />
  },
  {
    key: 'NATIVE',
    title: 'Nativo',
    description:
      'Crie botões, envie imagens, audios e muito mais nativamente.',
    icon: <BulbOutlined style={{ marginRight: 8 }} />,
  },
  {
    key: "GOOGLE_CALENDAR",
    title: "Google Calendar",
    description: "Utilize funções da integração com Google Calendar",
    icon: <CalendarOutlined style={{ marginRight: 8 }} />
  },
  {

    key: "CHAT_INTEGRATION",
    title: "Integração de Chat",
    description: "Utilize funções da integração com o chat",
    icon: <MessageOutlined style={{ marginRight: 8 }} />
  },
  {
    key: "CATALOG_INTEGRATION",
    title: "Integração de Catálogo",
    description: "Utilize funções da integração com o catálogo",
    icon: <ShopOutlined style={{ marginRight: 8 }} />
  },
  {
    key: 'CRM',
    title: 'CRM Nativo',
    description: 'Utilize funções do CRM nativo',
    icon: <UserOutlined style={{ marginRight: 8 }} />,
  }

]
export default function TemplateForm({ form, properties, trigger, loading }) {
  const navigate = useNavigate()

  return (
    <>
      <Typography.Title level={2}>Template</Typography.Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Form.Item
            name={'name'}
            rules={[{ required: true, message: "O nome é obrigatório" }]}
            label={'Nome'}
          >
            <Input placeholder={'Nome do Template'} />
          </Form.Item>
        </Col>
        <Col xs={24} md={10}>
          <Form.Item
            name={'description'}
            rules={[{ required: true, message: "A descrição é obrigatória" }]}
            label={'Descrição'}
          >
            <Input placeholder={'Descrição do Template'} />
          </Form.Item>
        </Col>
        <Col xs={24} md={4}>
          <Form.Item
            valuePropName="checked"
            // initialValue={true}
            name={'interpretResponse'}
            label={'Interpretar resposta'}
          >
            <Switch />
          </Form.Item>
        </Col>
        <Col xs={24} md={2}>
          <Form.Item
            valuePropName="checked"
            name={'isPublic'}
            label={'Público'}
          >
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Typography.Title level={4}>Gatilho</Typography.Title>
          <TriggerFormItems form={form} properties={properties} />
        </Col>
        <Col xs={24} md={12}>
          <Typography.Title level={4}>Ações</Typography.Title>
          <ActionFormItems isTemplate={true} form={form} cards={cards} parameters={trigger?.parameters} />
        </Col>
      </Row>
      <Space style={{ display: 'flex', justifyContent: 'end' }}>
        <Button onClick={() => navigate("/templates")} icon={<CloseOutlined />} danger>
          Cancelar
        </Button>
        <Button onClick={form.submit} icon={<SaveOutlined />} type="primary" loading={loading}>
          Salvar Template
        </Button>
      </Space>
    </>
  )
}
